<template>
    <uploads-store
        v-model="uploads"
        ref="uploads"
        :url="$laroute.route('api.uploads.store')"
        :max-files="maxFiles"
        :max-size="20"
        :disabled="disabled"
        @error="error = arguments[0]"
        v-slot="{
            isLoading: is_loading,
            removeFile: removeUpload,
            open
        }"
    >
        <button
            :class="{
                'is-invalid' : $validator.has(validatorName, sid),
                'is-disabled': disabled,
                'rounded-b-none': files.length || uploads.length
            }"
            class="relative pl-12 leading-none text-left cursor-pointer input"
            @click.prevent="open"
        >
            <div class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <base-svg
                    :name="is_loading ? 'icon-loading' : 'icon-cloud-upload'"
                    :key="is_loading ? 'icon-loading' : 'icon-cloud-upload'"
                    class="w-6 h-6"
                />
            </div>

            <div class="my-px overflow-hidden truncate">
                <span
                    class="opacity-50"
                >
                    Select files...
                </span>
            </div>
        </button>

        <div
            v-if="files.length || uploads.length"
            class="border border-t-0 rounded-b bg-grey-bg border-grey-lighter"
        >
            <draggable
                v-model="files"
                class="flex flex-wrap"
            >
                <input-uploads-item
                    v-for="(file, index) in files"
                    :key="file.uuid"
                    :index="index"
                    :is-thumbnail="showThumbs"
                    :name="file.name"
                    :img-src="file.object === 'file'
                        ? $laroute.route('storage.files.show', {
                            file: file.uuid,
                            width: 150
                        })
                        : $laroute.route('storage.uploads.show', {
                            upload: file.uuid,
                            width: 150
                        })
                    "
                    status="success"
                    class="p-3"
                    :class="showThumbs ? 'w-1/2 md:w-1/3': 'w-full'"
                    @remove="removeFile(file); if (file.upload) removeUpload(file.upload)"
                />
            </draggable>

            <input-uploads-item
                v-for="upload in _.reject(uploads, { status: 'success' })"
                :key="upload.id"
                :is-thumbnail="false"
                :name="upload.upload.filename"
                :status="upload.status"
                class="w-full p-3"
                @remove="removeUpload(upload)"
            />
        </div>
    </uploads-store>
</template>

<script>
    import _ from 'lodash'
    import Draggable from 'vuedraggable'
    import InputUploadsItem from './input-uploads-item'
    import UploadsStore from './uploads-store'

    export default {
        components: {
            Draggable,
            InputUploadsItem,
            UploadsStore
        },
        props: {
            value: {
                type: Array,
                required: true
            },
            sid: {
                type: String,
                required: true
            },
            maxFiles: {
                type: Number,
                default: 20
            },
            showThumbs: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace('[', '.').replace(']', '')
                }
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                files: [],
                uploads: []
            }
        },
        watch: {
            uploads () {
                this.files = _.uniqBy(this.files.concat(
                    _.chain(this.uploads)
                        .filter({
                            status: 'success'
                        })
                        .map(file => {
                            return _.extend(JSON.parse(file.xhr.response).data, {
                                upload: file
                            })
                        })
                        .value()
                ), 'uuid')
            },
            files () {
                // upload leaks into php://input
                this.$emit('input', _.map(this.files, file => _.omit(file, ['upload'])))
            }
        },
        created () {
            this.files = this.value
        },
        methods: {
            removeFile (file) {
                this.files = _.without(this.files, file)
            },
            reset () {
                this.files = []

                this.$refs.uploads.reset()
            }
        }
    }
</script>
